import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { appRoutes } from './app.route';

@NgModule({
    imports:[
        RouterModule.forRoot(appRoutes)
    ],
    exports:[RouterModule],
    providers:[]
})

export class AppRouteModule {};


// WEBPACK FOOTER //
// /var/www/html/project/snsina/src/app/app-route.module.ts